<!-- ImageComponent.vue -->
<template>
    <div>
        <Image :src="getUrl(url)" :alt="url" height="150" preview class="image-display"
            :class="{ 'blur': isBlurred }"  @click="toggleBlur" />
        <div v-if="isBlurred" @click="toggleBlur">{{ $t('chat.image_blurred') }}</div>
    </div>
</template>

<script>
export default {
    props: ['url'],
    data() {
        return {
            isBlurred: true
        }
    },
    methods: {
        toggleBlur() {
            if (this.isBlurred)
            this.isBlurred = !this.isBlurred;
        },
        getUrl(url) {
            if (!url)
                return null;
            if (url.startsWith('http://') || url.startsWith('https://'))
                return url;
            else
                return this.$socket_url +'/'+ url;
        }
    }
}

</script>

<style scoped>
.image-display {
    max-width: 100%;
    max-height: 150px;
}
.blur {
  filter: blur(8px);
  cursor: pointer;
  transition: filter 0.3s;
}
</style>